import type { FunctionComponent, MouseEventHandler } from "react"

import { Button } from "@jobteaser/spark/components/Button"

import { useTranslation } from "@/modules/i18n/components/useTranslation"

type ManageSlotsButtonProps = {
  handleClick: MouseEventHandler<HTMLButtonElement>
}

export const ManageSlotsButton: FunctionComponent<ManageSlotsButtonProps> = ({ handleClick }) => {
  const { t } = useTranslation(["event_details"])

  return (
    <Button
      onClick={handleClick}
      data-testid="event-details-registration-details-manage-slots-button"
      variant="secondary"
    >
      {t("event_details.slots.title")}
    </Button>
  )
}
